import { render, staticRenderFns } from "./ModalLightEdit.vue?vue&type=template&id=39cd4712&scoped=true"
import script from "./ModalLightEdit.vue?vue&type=script&lang=js"
export * from "./ModalLightEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalLightEdit.vue?vue&type=style&index=0&id=39cd4712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cd4712",
  null
  
)

export default component.exports